<template>
  <li class="price-vertical" :class="{ highlighted: highlighted }">
    <Title>{{ title }}</Title>
    <Price
      :price="
        isAnnually
          ? getMonthlyPriceEntire(price)
          : isMonthlyAnnualCommitment
          ? getMonthlyAnnualCommitmentEntire(price)
          : price
      "
      :decimal="
        isAnnually
          ? getMonthlyPriceDecimal(price)
          : isMonthlyAnnualCommitment
          ? getMonthlyAnnualCommitmentDecimal(price)
          : null
      "
      :currency-symbol="currencySymbol"
      :period="getPeriod"
      :is-monthly-annual-commitment="isMonthlyAnnualCommitment"
    />
    <InvoiceFrequency>
      <template v-if="isAnnually" #invoice-price> ${{ price }}</template>
      {{ getPriceDescription }}
    </InvoiceFrequency>
    <Button
      style="--primary-color: var(--terciary-color)"
      :highlighted="highlighted"
      :is-enabled="isButtonEnabled"
      @click="$emit('subscribe')"
    >
      {{ buttonText }}
    </Button>
    <Specs
      :highlighted="highlighted"
      :specs="specs"
      :see-more="seeMore"
      :see-less="seeLess"
      style="--primary-color: var(--secondary-color)"
      class="specs"
    />
  </li>
</template>
<script>
import Title from '@/components/Prices/PriceAtoms/Title';
import Price from '@/components/Prices/PriceAtoms/Price';
import Specs from '@/components/Prices/PriceAtoms/Specs';
import Button from '@/components/Prices/PriceAtoms/Button';
import InvoiceFrequency from '@/components/Prices/PriceAtoms/InvoiceFrequency';
import {
  getMonthlyPriceEntire,
  getMonthlyPriceDecimal,
  getMonthlyAnnualCommitmentDecimal,
  getMonthlyAnnualCommitmentEntire
} from '~/utils/common.js';
export default {
  components: {
    Title,
    Price,
    Button,
    Specs,
    InvoiceFrequency
  },
  props: {
    highlighted: {
      type: Boolean,
      default: false
    },
    price: {
      type: Number,
      required: true
    },
    period: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    buttonText: {
      type: String,
      required: true
    },
    priceDescription: {
      type: String,
      required: true
    },
    priceDescriptionAlt: {
      type: String,
      required: true
    },
    specs: {
      type: Array,
      required: true,
      validator: (specs) => {
        return specs.every((spec) => spec.title && spec.active);
      }
    },
    seeMore: {
      type: String,
      required: true
    },
    seeLess: {
      type: String,
      required: true
    },
    currencySymbol: {
      type: String,
      required: true
    },
    isButtonEnabled: {
      type: Boolean,
      required: true
    },
    isAnnually: {
      type: Boolean,
      required: true
    },
    isMonthlyAnnualCommitment: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getPriceDescription() {
      return this.isAnnually || this.isMonthlyAnnualCommitment
        ? this.priceDescription
        : `/${this.priceDescriptionAlt}`;
    },
    getPeriod() {
      return this.isAnnually || this.isMonthlyAnnualCommitment ? this.period : null;
    }
  },
  methods: {
    getMonthlyPriceEntire,
    getMonthlyPriceDecimal,
    getMonthlyAnnualCommitmentDecimal,
    getMonthlyAnnualCommitmentEntire
  }
};
</script>
<style lang="scss" scoped>
.price-vertical {
  --gradient-horizontal: linear-gradient(
    90deg,
    var(--primary-color) 0%,
    var(--secondary-color) 100%
  );
  --text-color: #{$mediumDarkGray};
  padding: 2rem 2rem 2rem;
  display: grid;
  justify-items: center;
  align-content: start;
  gap: 1em;
  color: var(--text-color);
  &.highlighted {
    --text-color: white;
    background: var(--gradient-vertical);
    height: 110%;
    transform: translateY(-5%);
    padding: 2.5em 2em 2.2em;
    border-radius: 15px;
  }
  .specs {
    justify-self: start;
  }
}
</style>
